
/**
 * @see https://github.com/Pomax/react-onclickoutside#marking-elements-as-skip-over-this-one-during-the-event-loop
 * */
export const ignoreOnclickoutsideClassName = 'ignore-react-onclickoutside';

export const defaultUserPhoto = require('../images/default_user.png');

export const reactSwitch = {
  width: 35,
  height: 19,
  color: '#44dc5d'
};

export const colors = {
  mint: '#44cbbd'
};

export const excludeFromSearchCriteria = [
  'full_name',
  'company_id'
];

export const debounceDefault = 500;



// WEBPACK FOOTER //
// ./src/constants/ui.js